/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChatEventChatEditedContentDto { 
    /**
     * Id чата, в котором событие
     */
    chatId: string;
    /**
     * Новое наименование чата
     */
    chatName: string;
    /**
     * Новое описание чата
     */
    chatDescription?: string | null;
    /**
     * Признак, что контент могут создавать только Админы
     */
    onlyForAdmins: boolean;
    /**
     * Признак, что у чата есть аватарка
     */
    isAvatarExists: boolean;
}

